import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * SecurityGuard: Implementa camadas de proteção contra inspeção e cópia.
 * - Bloqueio de F12, Ctrl+Shift+I/J/C, Ctrl+U.
 * - Bloqueio de botão direito (contextmenu) na página inicial.
 * - Armadilha de Debugger (apenas em Produção).
 */
const SecurityGuard: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // 1. Bloqueio de Teclas: F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U
    const handleKeyDown = (e: KeyboardEvent) => {
      /* Temporariamente desabilitado para debug
      // F12
      if (e.key === 'F12') {
        e.preventDefault();
        return false;
      }

      // Ctrl+Shift+I, J ou C (DevTools)
      if (e.ctrlKey && e.shiftKey && ['I', 'J', 'C', 'i', 'j', 'c'].includes(e.key)) {
        e.preventDefault();
        return false;
      }

      // Ctrl+U (Ver código fonte)
      if (e.ctrlKey && (e.key === 'U' || e.key === 'u')) {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+S (Salvar página)
      if (e.ctrlKey && (e.key === 'S' || e.key === 's')) {
        e.preventDefault();
        return false;
      }
      */
    };

    // 2. Bloqueio de Mouse: Apenas na página inicial ("/") conforme solicitado
    const handleContextMenu = (e: MouseEvent) => {
      /* Temporariamente desabilitado para debug
      if (location.pathname === '/') {
        e.preventDefault();
        return false;
      }
      */
    };

    // Adicionar listeners globais
    window.addEventListener('keydown', handleKeyDown, true);
    window.addEventListener('contextmenu', handleContextMenu, true);

    // 3. Debugger Trap: Loop para travar o console se aberto
    // Ativado apenas em ambiente de PRODUÇÃO
    let trapInterval: any;
    
    /* Temporariamente desabilitado para debug
    if (import.meta.env.PROD) {
      const detectDevTools = () => {
        const startTime = performance.now();
        debugger; // Interrompe aqui se o DevTools estiver aberto
        const endTime = performance.now();
        
        // Se o tempo de execução foi longo (>100ms), o DevTools provavelmente está aberto
        if (endTime - startTime > 100) {
           // Força loops recursivos para inundar o stack do debugger
           for (let i = 0; i < 50; i++) {
             (function() {
               (function() {
                 debugger;
               }());
             }());
           }
        }
      };

      trapInterval = setInterval(detectDevTools, 2000);
    }
    */

    return () => {
      window.removeEventListener('keydown', handleKeyDown, true);
      window.removeEventListener('contextmenu', handleContextMenu, true);
      if (trapInterval) clearInterval(trapInterval);
    };
  }, [location.pathname]);

  return null;
};

export default SecurityGuard;
